import i18next from 'i18next';

import { deleteThumbnail } from 'common/api/thumbnails';
import alerts from 'common/modules/alerts';
import showToast from 'common/utils/showToast';

import {
    DELETE_THUMBNAIL,
    DELETE_THUMBNAIL_FAILURE,
    DELETE_THUMBNAIL_SUCCESS,
} from '../actionTypes';
import { productThumbnailActions } from '../reducer';

import fetchProductThumbnail from './fetchProductThumbnail';

export default (productId) => (dispatch) => {
    dispatch(productThumbnailActions[DELETE_THUMBNAIL]());

    deleteThumbnail(productId)
        .then(() => {
            dispatch(productThumbnailActions[DELETE_THUMBNAIL_SUCCESS]({}));
            dispatch(fetchProductThumbnail(productId));
            showToast({
                body: i18next.t('It was successfully removed'),
            });
        })
        .catch((error) => {
            dispatch(
                productThumbnailActions[DELETE_THUMBNAIL_FAILURE](
                    error.response.data.errors,
                ),
            );

            const dataAlert = {
                confirmText: i18next.t('Close'),
                messages: [
                    `${i18next.t('Whoops, something went wrong')}:`,
                    ...error.response.data.errors,
                ],
                title: i18next.t('Error'),
                type: alerts.ALERT_TYPE_ALERT,
                variant: 'error',
            };

            dispatch(alerts.actions.show(dataAlert));
        });
};
